import React, { Component } from 'react';
import { Container } from 'semantic-ui-react';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  

  render () {
    return (
      <Container fluid>
        <NavMenu />
        {this.props.children}
      </Container>
    );
  }
}
